import { render, staticRenderFns } from "./order-status-label.vue?vue&type=template&id=4dadfdb8&"
import script from "./order-status-label.vue?vue&type=script&lang=ts&"
export * from "./order-status-label.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports